/* UR LUXURY · neues Aussehen: Kopf, Menü, Einblenden, Kundenstimmen. Berührt keine Formulare. */
(() => {
  'use strict';
  if (window.URLookLoaded) return;
  window.URLookLoaded = true;
  const doc = document.documentElement;
  doc.classList.add('urx-js');

  const hdr = document.querySelector('.urx-hdr');
  const hero = document.querySelector('.urx-hero');
  const heroWrap = hero && hero.closest('.shopify-section');
  let ticking = false;
  function onScroll() {
    const y = window.scrollY;
    const h = hero ? hero.offsetHeight : 0;
    if (hdr) hdr.classList.toggle('is-solid', !hero || y > h - 90 || document.body.classList.contains('urx-menu-open'));
    if (hero) {
      hero.style.setProperty('--urx-p', Math.min(1, Math.max(0, y / h)).toFixed(3));
      if (heroWrap) heroWrap.style.visibility = y > h * 1.6 ? 'hidden' : 'visible';
    }
    ticking = false;
  }
  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();

  const burger = document.querySelector('.urx-burger');
  const sheet = document.querySelector('.urx-sheet');
  function setMenu(open) {
    document.body.classList.toggle('urx-menu-open', open);
    if (burger) burger.setAttribute('aria-expanded', String(open));
    if (sheet) sheet.setAttribute('aria-hidden', String(!open));
    onScroll();
  }
  if (burger) burger.addEventListener('click', () => setMenu(!document.body.classList.contains('urx-menu-open')));
  if (sheet) sheet.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setMenu(false)));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') setMenu(false); });

  document.querySelectorAll('[data-urx-quotes]').forEach(box => {
    const figs = Array.from(box.querySelectorAll('figure'));
    const pos = box.parentElement.querySelector('[data-urx-qpos]');
    if (!figs.length) return;
    let k = 0, timer;
    const show = n => {
      k = (n + figs.length) % figs.length;
      figs.forEach((f, i) => f.classList.toggle('on', i === k));
      if (pos) pos.textContent = String(k + 1).padStart(2, '0') + ' / ' + String(figs.length).padStart(2, '0');
    };
    const auto = () => { clearInterval(timer); timer = setInterval(() => show(k + 1), 7000); };
    const next = box.parentElement.querySelector('[data-urx-next]');
    const prev = box.parentElement.querySelector('[data-urx-prev]');
    if (next) next.addEventListener('click', () => { show(k + 1); auto(); });
    if (prev) prev.addEventListener('click', () => { show(k - 1); auto(); });
    show(0); auto();
  });

  document.querySelectorAll('[data-urx-models]').forEach(box => {
    const buttons = box.querySelectorAll('.urx-models__filter button');
    const cards = box.querySelectorAll('.urx-model-card');
    buttons.forEach(btn => btn.addEventListener('click', () => {
      buttons.forEach(b => b.classList.toggle('on', b === btn));
      const brand = btn.dataset.brand;
      cards.forEach(c => { c.hidden = !!brand && c.dataset.brand !== brand; });
    }));
  });

  const items = document.querySelectorAll('.urx-rv');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('seen'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    items.forEach(el => io.observe(el));
  } else items.forEach(el => el.classList.add('seen'));
})();
